(function () {
  'use strict';

  var injected = typeof WeakSet !== 'undefined' ? new WeakSet() : null;

  var WISHLIST_CSS = [
    'button.gw-btn {',
    '  background: transparent !important;',
    '  border: none !important;',
    '  box-shadow: none !important;',
    '  padding: 8px 4px !important;',
    '  color: inherit !important;',
    '  display: inline-flex !important;',
    '  align-items: center !important;',
    '  justify-content: center !important;',
    '  gap: 6px !important;',
    '  font-size: 12px !important;',
    '  font-family: inherit !important;',
    '  line-height: 1 !important;',
    '  height: auto !important;',
    '  min-height: unset !important;',
    '  width: 100% !important;',
    '  cursor: pointer !important;',
    '}',
    '.gw-wl-add-to-wishlist-btn__inner {',
    '  display: inline-flex !important;',
    '  align-items: center !important;',
    '  gap: 6px !important;',
    '}',
    '.gw-wl-add-to-wishlist-btn__inner svg {',
    '  width: 22px !important;',
    '  height: 22px !important;',
    '  flex-shrink: 0 !important;',
    '}',
    '.gw-wl-add-to-wishlist-btn__inner span {',
    '  font-size: 12px !important;',
    '  font-family: inherit !important;',
    '  letter-spacing: 0.02em !important;',
    '}'
  ].join('\n');

  function injectIntoShadowRoot(shadowRoot) {
    if (injected && injected.has(shadowRoot)) return;
    var existing = shadowRoot.querySelector('[data-gw-custom-styles]');
    if (existing) existing.remove();
    var style = document.createElement('style');
    style.setAttribute('data-gw-custom-styles', 'true');
    style.textContent = WISHLIST_CSS;
    shadowRoot.prepend(style);
    if (injected) injected.add(shadowRoot);
  }

  function processWishlist() {
    var placeholders = document.querySelectorAll('.gw-wl-add-to-wishlist-placeholder');
    for (var i = 0; i < placeholders.length; i++) {
      if (placeholders[i].shadowRoot) {
        injectIntoShadowRoot(placeholders[i].shadowRoot);
      }
    }
  }

  [0, 300, 800, 1500, 3000].forEach(function (ms) {
    if (ms === 0) { processWishlist(); } else { setTimeout(processWishlist, ms); }
  });

  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(processWishlist)
      .observe(document.documentElement, { childList: true, subtree: true });
  }
})();
